import React from 'react';
import styled from 'styled-components';
import PageV3 from './PageV3';

interface PageProps {
  children?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
}

const Page: React.FC<PageProps> = ({ children }) => {
  return (
    <PageV3>
      {children}
    </PageV3>
  );
};

export default Page;